import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ModelosContables from './ModelosContables.jsx';
import * as actions from '../actions/Actions.js';

const mapStateToProps = (state) => {
    return {
        data: state.modelosContables,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch) => { return { actions: bindActionCreators(actions, dispatch) } }

const ModelosContablesContainer = connect(mapStateToProps, mapDispatchToProps)(ModelosContables);


export default ModelosContablesContainer;